import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination, FreeMode } from "swiper/modules";

export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    this.notEnoughSlides();

    const options = {
      ...this.defaultOptions,
      ...this.optionsValue,
    };

    if (options.navigation) {
      const parent = this.element.parentElement;
      if (parent) {
        const nextEl = parent.querySelector(options.navigation.nextEl);
        const prevEl = parent.querySelector(options.navigation.prevEl);
        if (nextEl || prevEl) {
          options.navigation = {
            ...options.navigation,
            nextEl: nextEl || options.navigation.nextEl,
            prevEl: prevEl || options.navigation.prevEl,
          };
        }
      }
    }

    this.swiper = new Swiper(this.element, options);
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  get defaultOptions() {
    return {
      modules: [Navigation, Pagination, FreeMode],
      freeMode: {
        enabled: true,
        minimumVelocity: 0.2,
        momentum: false,
      },
      slidesPerView: 4.2,
      spaceBetween: 10,
      grabCursor: true,
    };
  }

  notEnoughSlides() {
    const slides = this.element.querySelectorAll(".swiper-slide");

    const maxSlides = 1;

    if (slides.length < maxSlides) {
      this.element.classList.add("not-enough-slides");
    } else {
      this.element.classList.remove("not-enough-slides");
    }
  }
}
